import script from "./EmployesView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployesView.vue?vue&type=script&setup=true&lang=js"

import "./EmployesView.vue?vue&type=style&index=0&id=30877865&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30877865"]])

export default __exports__